var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6C7 7.1046 6.10457 8 5 8C3.89543 8 3 7.1046 3 6C3 4.8954 3.89543 4 5 4C6.10457 4 7 4.8954 7 6Z",
    stroke: "#494444",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 2H4.3C2.47746 2 1 3.79086 1 6C1 8.20913 2.47746 10 4.3 10H8.7C10.5225 10 12 8.20913 12 6C12 3.79086 10.5225 2 8.7 2Z",
    stroke: "#494444",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOff);
export default __webpack_public_path__ + "static/media/toggle-off.85c6f4488f8a20034a7311ae950b8c16.svg";
export { ForwardRef as ReactComponent };